import * as actions from './actionTypes';
import { OfferSearch, SMEReport } from 'api';

export const getReport = (filter?: OfferSearch) => ({
	type: actions.GET_REPORT,
	payload: filter,
});

export const setSmeReport = (report?: SMEReport[]) => ({
	type: actions.SET_SME_REPORT,
	payload: report,
});

export const resetReports = () => ({
	type: actions.RESET_REPORTS,
});
